import { gateway } from "../../gateway";

export interface ValidateTokenArgs {
    token: string;
    checkById?: boolean;
    checkByParam?: boolean;
}

export type ValidateTokenResponse = {
    isValid: boolean
    user?: unknown;
}



export const validateToken = async ({
    token,
    checkById,
    checkByParam,
}: ValidateTokenArgs): Promise<ValidateTokenResponse> => {
    const params = new URLSearchParams();
    if (checkById) params.set("usagelimit", "true");
    if (checkByParam) params.set("isGeneric", "true");

    const query = params.toString();

    const res = await gateway.get(`/tokens/validate${query ? `?${query}` : ""}`, {
        headers: { Authorization: token },
    });

    const status = res.data?.status;
    const data = res.data?.data;

    return {
        isValid: status === 200,
        user: data?.user ?? undefined,
    };
};